import { render } from "./FileItem.vue?vue&type=template&id=4d670548&scoped=true"
import script from "./FileItem.vue?vue&type=script&lang=ts"
export * from "./FileItem.vue?vue&type=script&lang=ts"

import "./FileItem.vue?vue&type=style&index=0&id=4d670548&lang=scss&scoped=true"
import "./FileItem.vue?vue&type=style&index=1&id=4d670548&lang=scss"
script.render = render
script.__scopeId = "data-v-4d670548"

export default script